import { Registration } from '@app/_store';

export class ActivityStateModel {
  currentActivity: Activity;
  templates: ActivityItem[];
  archives: Archive[];
  createError: boolean;
  activities: ActivityListItem[];
  paymentSearchResult: PaymentSearchResult[];
  isExportingOrImporting: boolean;
}

export class PaymentSearchResult {
  id: string;
  activityName: string;
  organizationId: string;
  organizationName: string;
  isArchived: boolean;
  group?: string;
  participantId?: string;
  participantName: string;
  paymentId?: string;
  amount: number;
  timestamp: Date;
}

export class ActivitySummary {
  total: number;
  payments: number;
  balance: number;
}

export class ArchiveList {
  archives: Archive[];
}

export class Archive {
  id: string;
  archiveName: string;
  files: ArchiveFile[];
  hasProductImagesFile: boolean;
}

export class ArchiveFile {
  name: string;
  url: string;
}

export class ActivityList {
  activities: ActivityListItem[];
}

export class ActivityItem {
  id: string;
  name: string;
  imageUrl: string;
  productCount: number;
  responsible: string;
}

export class ActivityListItem extends ActivityItem {
  type: string;
  publishedAsTemplate?: boolean;
  participantCount: number;
  productSelectionDeadline: Date;
  paymentDeadline: Date;
}

export class Activity {
  id: string;
  name: string;
  type: string;
  description: string;
  publishedAsTemplate?: boolean;
  templateMessage: string;
  templateReferenceId: string;
  deliveryInformation: string;
  imageUrl: string;
  imageSize?: Size;
  products: ActivityProduct[];
  productSelectionReminderEnabled: boolean;
  productSelectionDeadline: Date;
  productSelectionDeadlineSuggestion: Date;
  productSelectionReminders: Date[];
  paymentReminderEnabled: boolean;
  paymentDeadline: Date;
  paymentDeadlineSuggestion: Date;
  paymentReminders: Date[];
  haveUserSelectableProducts: boolean;
  summary: ActivitySummary;
  archiving: Archiving;
  responsible: {
    name: string;
    email: string;
  };
  settings: ActivitySettings;
  registration: Registration;
  updateRequired: boolean;
  integrationData: Record<string, unknown>[];
}

export class Size {
  width: number;
  height: number;
}

export class Archiving {
  nextCheck?: Date;
  forceArchive?: boolean;
}

export class ActivitySettings {
  partialPaymentAllowed: boolean;
  smsPaymentReminderEnabled: boolean;
  subParticipantsAllowed: boolean;
  subParticipantSwishOption?: SubParticipantSwishOptions;
  swish: { name: string; number: string };
}

export class ActivityProduct {
  id: string;
  title: string;
  description: string;
  amount: number;
  profit?: number;
  isUserSelectable: boolean;
  quantityType: QuantityType;
  defaultQuantity?: number;
  isDeliverable: boolean;
  locked: boolean;
  requireComment: boolean;
  options: ActivityProductOption[];
  images: ActivityProductImage[];
  restrictions: ActivityProductRestrictions;
  costDistributions: ActivityProductDistribution[];
  profitDistributions: ActivityProductDistribution[];
}

export class ActivityProductDistribution {
  name: string;
  percent: number;
}

export class ActivityProductRestrictions {
  maximumAmount?: number;
  maximumPerGroup?: number;
  maximumPerParticipant?: number;
}

export class ActivityProductImage {
  id: string;
  url: string;
  text: string;
}

export enum SubParticipantSwishOptions {
  Both = 0,
  Participant = 1,
  Organization = 2,
}

export enum QuantityType {
  OneTime = 0,
  Choosable = 1,
}

export class ActivityProductOption {
  title: string;
  required: boolean;
  isMultiSelect: boolean;
  requireCommentOnProduct: boolean;
  options: OptionItem[];
}

export class OptionItem {
  text: string;
  priceAdjustment: number;
}
